const ITEMS = [
  "The Violent Fan",
  "110,000 RPM",
  "33 M/S Jet Stream",
  "Canned Air Is Dead",
  "Variable Speed Control",
  "8,000 mAh",
  "USB-C Fast Charge",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-steel bg-carbon py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg font-bold uppercase tracking-wider text-foreground/80">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-volt" />
          </span>
        ))}
      </div>
    </div>
  );
};
